export default __webpack_public_path__ + "static/media/RAPPORT GENERAL DES ACTIVITES 2020.dfb2d5cb.pdf";